
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.828 14.29H4.01l4.111-4.223c.46-.471.461-1.237.004-1.71a1.146 1.146 0 00-1.657-.005l-6.123 6.29-.001.002a1.239 1.239 0 000 1.712v.001l6.124 6.29c.459.472 1.2.47 1.657-.003a1.237 1.237 0 00-.004-1.711l-4.11-4.223h24.817c.647 0 1.172-.542 1.172-1.21 0-.668-.525-1.21-1.172-1.21z","fill":"#323232"}})])
          )
        }
      }
    